export const B2T_COLUMN_STATE_STORAGE_KEY = 'b2tdiffColumnState';

export const eventSources = {
  TOOL_PANEL_UI: 'toolPanelUi',
  COLUMN_MENU: 'columnMenu',
  API: 'api',
  SIZE_COLUMNS_TO_FIT: 'sizeColumnsToFit',
};
